import type { LegalSection } from "../lib/legal/types";
import { LegalTableOfContents } from "./LegalTableOfContents";

type LegalStickyTocProps = {
  sections: LegalSection[];
};

/**
 * Desktop: sticky column on the end side (right in LTR).
 * Mobile: fixed bar at the bottom so the TOC stays visible while scrolling.
 */
export function LegalStickyToc({ sections }: LegalStickyTocProps) {
  return (
    <>
      {/* Desktop: grid column is as tall as the article — sticky keeps TOC in view */}
      <aside className="relative hidden md:block md:row-span-1">
        <div className="sticky top-28 z-20 w-full">
          <LegalTableOfContents sections={sections} />
        </div>
      </aside>

      {/* Mobile: fixed bottom panel — does not block page scroll */}
      <aside
        className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t border-border-soft bg-bg-base/95 px-4 py-3 shadow-[0_-8px_30px_rgba(0,0,0,0.08)] backdrop-blur-md dark:bg-bg-base/90 dark:shadow-[0_-8px_30px_rgba(0,0,0,0.35)]"
        aria-label="Table of contents"
      >
        <LegalTableOfContents sections={sections} variant="compact" />
      </aside>
    </>
  );
}
